<template>
  <div class="addProject">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>商品</el-breadcrumb-item>
      <el-breadcrumb-item>商品管理</el-breadcrumb-item>
      <el-breadcrumb-item :to="'/physicalCommodityList'">实物商品列表</el-breadcrumb-item>
      <el-breadcrumb-item>添加实物商品</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="stepList boxLayout">
      <el-steps :space="'50%'" :active="active" finish-status="success" align-center>
        <el-step title="编辑商品基本信息"></el-step>
        <el-step title="编辑商品详情"></el-step>
        <el-step title="编辑商品参数"></el-step>
        <el-step title="编辑售后保障"></el-step>
      </el-steps>
    </div>
    <div class="info mg-t-20" v-show="active === 0">
      <el-form ref="basicInfoForm" :model="basicInfoForm" label-width="80px" :rules="rules">
        <div class="boxLayout">
          <h3 class="title-t mg-b-30">基础信息</h3>
          <el-form-item label="项目图片" prop="image">
            <span slot="label"><span style="color: red">*</span>商品图片</span>
            <uploadImagesBtn @getImageUrl="getImageUrl" />
            <el-button type="text" @click="chooseBanners">从素材库选择</el-button>
            <div class="cover_image_list flex" v-if="basicInfoForm.image.length > 0">
              <draggable v-model="basicInfoForm.image" group="image">
                <div class="img" v-for="(item, index) in basicInfoForm.image" :key="index">
                  <i class="el-icon-delete" @click.stop="deleteImg(index)"></i>
                  <el-image :src="item" fit="cover"></el-image>
                </div>
              </draggable>
            </div>
            <p class="font-12 color-999">建议尺寸：800*800像素，拖拽图片可以调整顺序，最多上传15张</p>
          </el-form-item>
          <el-form-item label="商品视频">
            <el-button class="avatar-uploader video" @click="chooseVideo">
              <video v-if="basicInfoForm.video !== ''" width="178px" controls>
                <source :src="basicInfoForm.video" />
              </video>
              <i class="el-icon-delete" v-if="basicInfoForm.video !== ''" @click.stop="basicInfoForm.video = ''"></i>
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-button>
            <p class="font-12 color-999">视频最长支持10分钟</p>
          </el-form-item>
          <el-form-item label="商品名称" prop="name">
            <el-input style="width: 400px" v-model="basicInfoForm.name"></el-input>
          </el-form-item>
          <el-form-item label="商品编码">
            <el-input style="width: 220px" v-model="basicInfoForm.code"></el-input>
          </el-form-item>
          <el-form-item label="商品分类" prop="category_uuid">
            <el-select v-model="basicInfoForm.category_uuid" placeholder="请选择">
              <el-option-group v-for="group in options" :key="group.uuid" :label="group.name" :value="group.uuid">
                <el-option v-for="item in group.children" :key="item.uuid" :label="item.name" :value="item.uuid"> </el-option>
              </el-option-group>
            </el-select>
          </el-form-item>
          <el-form-item label="权重">
            <el-input v-model="basicInfoForm.show_order" type="number"></el-input>
          </el-form-item>
          <el-form-item label="重量" prop="weight">
            <el-input style="width: 220px" v-model="basicInfoForm.weight"><i slot="suffix"> kg </i></el-input>
          </el-form-item>
          <el-form-item label="投放人群" prop="group_uuid">
            <el-select multiple collapse-tags v-model="basicInfoForm.group_uuid" placeholder="请选择">
              <el-option v-for="(jtem, i) in userGroupList" :key="i" :label="jtem" :value="i"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选择品牌" prop="supplier_uuid">
            <el-select v-model="basicInfoForm.supplier_uuid" placeholder="请选择">
              <el-option v-for="jtem in brandList" :key="jtem.uuid" :label="jtem.name" :value="jtem.uuid"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否会员服务" prop="is_service">
            <el-select v-model="basicInfoForm.is_service" placeholder="请选择">
              <el-option label="是" value="1"></el-option>
              <el-option label="否" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="商品类型" prop="show_type">
            <el-select v-model="basicInfoForm.show_type" placeholder="请选择">
              <el-option label="博雅商城" value="1"></el-option>
              <el-option label="权益专区" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="添加标签" prop="label_uuid">
            <el-tag v-for="tag in tags" :key="tag.uuid" :type="tag.type">
              {{ tag.name }}
            </el-tag>
            <span style="color: cornflowerblue; cursor: pointer" @click="labelDialogVisible = true">
              <span v-if="tags.length > 0">+ 编辑标签</span>
              <span v-else>+ 添加标签</span>
            </span>
          </el-form-item>
        </div>
        <div class="boxLayout mg-t-20">
          <h3 class="title-t mg-b-20">规格信息</h3>
          <el-form-item label="规格设置">
            <el-select
              v-model="attributeValue"
              multiple
              filterable
              placeholder="添加规格"
              value-key="uuid"
              @change="selectAttribute"
              @remove-tag="deleteAttribute"
            >
              <el-option v-for="item in attributeList" :key="item.uuid" :label="item.name" :value="item"> </el-option>
            </el-select>
            <!-- <el-button type="primary" @click="addUnit">添加规格</el-button> -->
            <SkuForm
              :key="randomDate"
              ref="skuForm"
              :source-attribute="sourceAttribute"
              :structure="structure"
              :attribute.sync="attribute"
              :sku.sync="sku"
              :isEdit="isEdit"
              :async="isEdit"
              :showBmsCode="true"
            >
              <template #image="slotProps">
                <el-button class="avatar-uploader" @click="chooseSpecImg(slotProps)">
                  <img v-if="slotProps.row.image !== ''" :src="slotProps.row.image" class="avatar small" />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  <i v-if="slotProps.row.image !== ''" class="el-icon-delete" @click.stop="slotProps.row.image = ''"></i>
                </el-button>
              </template>
            </SkuForm>
            <!-- <specs @getAttributeData="getAttributeData" ref="spec" :attributes="basicInfoForm.attribute" :newTemplateDatas="basicInfoForm.specs"/> -->
            <p class="font-12 color-999 mg-t-10">批量设置，输入完后按Enter键确认</p>
          </el-form-item>
          <el-form-item label="零售价" prop="price">
            <el-input v-model="basicInfoForm.price" class="ipt" placeholder="请输入"><template slot="prepend">元</template></el-input>
            <br />
            <el-checkbox v-model="basicInfoForm.show_less_price_mark">是否显示起</el-checkbox>
          </el-form-item>
          <el-form-item label="划线价">
            <el-input v-model="basicInfoForm.crossed_price" class="ipt" placeholder="请输入"><template slot="prepend">元</template></el-input>
            <br />
            <el-checkbox v-model="basicInfoForm.show_crossed_price">是否显示划线价</el-checkbox>
          </el-form-item>

          <el-form-item label="支付方式" prop="pay_type">
            <el-checkbox v-model="basicInfoForm.only_cash" :checked="true" disabled>现金</el-checkbox>
            <el-checkbox v-model="basicInfoForm.cash_score" @change="isSelect1">现金+积分</el-checkbox>
            <el-checkbox v-model="basicInfoForm.customize_score" @change="isSelect">自定义积分</el-checkbox>
          </el-form-item>
          <el-form-item label="" v-if="basicInfoForm.cash_score == true || basicInfoForm.customize_score == true">
            <el-input v-model="basicInfoForm.score" class="ipt" placeholder="请输入"><template slot="prepend">分</template></el-input>
            <br />
          </el-form-item>
          <el-form-item label="收款单位" prop="collecting_company">
            <el-select v-model="basicInfoForm.collecting_company" placeholder="请选择" style="width: 300px">
              <el-option v-for="item in collecting_company_opts" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="销量" prop="sales_number">
            <span>{{ basicInfoForm.sales_number }}</span>
          </el-form-item>
        </div>

        <div class="boxLayout mg-t-20">
          <h3 class="title-t mg-b-20">物流配送</h3>
          <el-form-item label="配送方式" prop="is_express_delivery">
            <el-checkbox disabled v-model="basicInfoForm.is_express_delivery">快递发货</el-checkbox>
          </el-form-item>
          <el-form-item label="发货地" prop="deliver_place_area">
            <el-checkbox disabled v-model="basicInfoForm.is_deliver_place">设置发货地</el-checkbox>
            <el-cascader
              class="mg-l-20"
              v-model="value"
              :options="cityList"
              @change="getCityValue"
              :props="props"
              collapse-tags
              clearable
            ></el-cascader>
          </el-form-item>
          <el-form-item label="运费设置">
            <el-radio-group v-model="basicInfoForm.freight_setting" :prop="basicInfoForm.freight_setting == 2 ? 'freight_uuid' : ''">
              <el-radio :label="1">包邮</el-radio>
              <div class="flex mg-t-10 align-center">
                <el-radio :label="2">运费模板</el-radio>
                <el-select v-model="basicInfoForm.freight_uuid" placeholder="请选择" v-if="basicInfoForm.freight_setting == 2">
                  <el-option v-for="jtem in freghtList" :key="jtem.uuid" :label="jtem.name" :value="jtem.uuid"> </el-option>
                </el-select>
                <el-button type="text" class="mg-l-20" @click="$router.push('/freightTemplate')" v-if="basicInfoForm.freight_setting == 2">
                  + 模板管理</el-button
                >
              </div>
            </el-radio-group>
          </el-form-item>
        </div>
        <div class="boxLayout mg-t-20">
          <h3 class="title-t mg-b-20">其它设置</h3>
          <el-form-item label="售后服务">
            <el-checkbox v-model="basicInfoForm.allow_return">允许买家申请退货</el-checkbox><br />
            <el-checkbox v-model="basicInfoForm.seven_days">7天无理由</el-checkbox>
          </el-form-item>
          <el-form-item label="上架设置">
            <el-radio-group v-model="basicInfoForm.status">
              <el-radio :label="1">立即上架</el-radio>
              <el-radio :label="2">暂不上架</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="开售时间" v-if="basicInfoForm.status == 1">
            <el-radio-group v-model="basicInfoForm.shelf_type">
              <el-radio :label="1">立即开售</el-radio>
              <el-radio :label="2">定时开售</el-radio>
              <el-date-picker
                v-model="basicInfoForm.shelf_time"
                v-if="basicInfoForm.shelf_type == 2"
                type="datetime"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy/MM/dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
                @change="getTimes"
                :picker-options="pickerOptions"
              >
              </el-date-picker>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="限购">
            <el-checkbox v-model="basicInfoForm.is_purchase_limit">设置每人限购数量</el-checkbox>
            <el-input v-model="basicInfoForm.purchase_limit" class="ipt mg-l-20" placeholder="请输入"
              ><template slot="prepend">件</template></el-input
            >
            <br />
            <div class="flex align-center mg-t-10">
              <el-checkbox v-model="basicInfoForm.is_appoint_level">设置指定等级会员购买</el-checkbox>
              <el-select class="mg-l-20" v-model="basicInfoForm.appoint_level" placeholder="请选择">
                <el-option v-for="(jtem, i) in levelList" :key="i" :label="jtem" :value="i"> </el-option>
              </el-select>
              <el-input v-model="basicInfoForm.appoint_level_num" class="ipt mg-l-20" placeholder="请输入"
                ><template slot="prepend">件</template></el-input
              >
              <br />
            </div>
          </el-form-item>
          <el-form-item label="隐藏销量">
            <el-checkbox v-model="basicInfoForm.hide_sales">不显示该商品销量</el-checkbox>
            <el-input v-model="basicInfoForm.sales_number" class="ipt mg-l-20" placeholder="请输入"><template slot="prepend">件</template></el-input>
            <br />
          </el-form-item>
          <el-form-item label="隐藏商品">
            <el-checkbox v-model="basicInfoForm.hide_goods">设置商品不在商城中显示</el-checkbox>
          </el-form-item>
          <el-form-item label="商品推广">
            <el-checkbox v-model="basicInfoForm.goods_extend">允许插入资讯内容中推广</el-checkbox>
          </el-form-item>
          <el-form-item label="推广佣金">
            <el-switch v-model="basicInfoForm.extend_commission" :active-value="1" :inactive-value="2" active-color="#13ce66" inactive-color="gray">
            </el-switch>
            <p class="font-12 color-999">启用后，商品推广可获得佣金</p>
          </el-form-item>
          <el-form-item label="评价默认">
            <el-input v-model="basicInfoForm.default_comment_num" class="ipt" placeholder="请输入"> </el-input>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="info boxLayout mg-t-20" v-show="active === 1">
      <h3 class="title-t mg-b-30">商品详情</h3>
      <wangEditorTool ref="detailEditor" :content="basicInfoForm.goods_detail" />
    </div>
    <div class="info boxLayout mg-t-20" v-show="active === 2">
      <h3 class="title-t mg-b-30">商品参数</h3>
      <wangEditorTool ref="parameterEditor" :content="basicInfoForm.goods_parameter" />
    </div>
    <div class="info boxLayout mg-t-20" v-show="active === 3">
      <h3 class="title-t mg-b-30">售后保障</h3>
      <wangEditorTool ref="saleEditor" :content="basicInfoForm.after_sale" />
    </div>
    <div class="operateBtn">
      <el-button type="primary" size="mini" v-if="active !== 0" @click="toPrev">上一步</el-button>
      <el-button type="primary" v-if="active !== 3" size="mini" @click="toNext">下一步</el-button>
      <el-button type="primary" size="mini" v-if="active === 3" @click="submitForm('basicInfoForm')">保存</el-button>
      <el-button size="mini" @click="$router.go(-1)">返回</el-button>
    </div>
    <el-dialog :title="title" :visible.sync="dialogVisible" width="80%" :close-on-click-modal="false">
      <MaterialLibrary :type="imgType" @selectImg="selectImg" @insertVideoHandler="insertVideoHandler" />
      <span slot="footer" class="dialog-footer text-center">
        <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog title="选择标签" :visible.sync="labelDialogVisible" width="80%" :close-on-click-modal="false">
      <markLabel @closeDialog="closeDialog" :tags="tags" :type="'addCustomer'" />
    </el-dialog>
    <el-dialog title="选择图片" :visible.sync="dialogImageVisible" width="80%" :close-on-click-modal="false">
      <imageDialog @closeImageDialog="closeImageDialog" @confirmImageDialog="confirmImageDialog" />
    </el-dialog>
  </div>
</template>
<script>
  import draggable from "vuedraggable";
  import markLabel from "../../../components/markLabel.vue";
  import MaterialLibrary from "../../../components/materialLibraryDialog/index";
  import wangEditorTool from "../../../components/wangEditorTool.vue";
  import imageDialog from "../../../components/imageDialog.vue";
  import uploadImagesBtn from "../../../components/uploadImagesBtn.vue";
  import SkuForm from "../../../components/skuForm.vue";
  export default {
    name: "addProject",
    components: {
      draggable,
      markLabel,
      MaterialLibrary,
      wangEditorTool,
      SkuForm,
      imageDialog,
      uploadImagesBtn,
    },
    // provide() {
    //   return {
    //     globalData: this.sku
    //   }
    // },
    data() {
      return {
        dialogImageVisible: false,
        active: 0,
        value: "",
        props: {
          label: "area_name",
          value: "area_id",
        },
        pickerOptions: {
          disabledDate: (time) => {
            // 禁用今天之前的日期选择
            return time.getTime() < new Date().getTime() - 24 * 60 * 60 * 1000;
          },
        },
        collecting_company_opts: [
          { label: "博雅干细胞科技有限公司", value: "博雅干细胞科技有限公司" },
          { label: "无锡洋百科医疗科技有限公司", value: "无锡洋百科医疗科技有限公司" },
          { label: "瑞富达生物技术无锡有限公司", value: "瑞富达生物技术无锡有限公司" },
          // { label: "无锡英科博雅医疗管理有限公司", value: "无锡英科博雅医疗管理有限公司" },
        ],
        randomDate: new Date().getTime(),
        sourceAttribute: [],
        structure: [],
        attribute: [],
        sku: [],
        isEdit: false,
        tags: [],
        imgType: "",
        inputVisible: false,
        title: "选择图片",
        slotProps: {},
        dialogVisible: false,
        labelDialogVisible: false,
        options: [],
        storeList: [],
        userGroupList: [],
        brandList: [],
        cityList: [],
        insertImgType: "",
        specificateOptions: [],
        freghtList: [],
        levelList: [],
        // 添加规格
        basicInfoForm: {
          is_service: "",
          show_type: "",
          weight: "",
          freight_uuid: "",
          category_uuid: "",
          supplier_uuid: "",
          appoint_level: "",
          purchase_limit: "",
          show_order: "",
          sales_number: 0,
          allow_return: false,
          is_purchase_limit: false,
          is_appoint_level: false,
          appoint_level_num: "",
          seven_days: false,
          only_cash: true,
          cash_score: false,
          customize_score: false,
          collecting_company: "无锡洋百科医疗科技有限公司",
          is_express_delivery: true,
          is_deliver_place: true,
          show_crossed_price: false,
          show_less_price_mark: false,
          hide_sales: false,
          hide_goods: false,
          goods_extend: false,
          video: "",
          image: [],
          name: "",
          group_uuid: [],
          code: "",
          price: "",
          crossed_price: "",
          label_uuid: "",
          score: "",
          shelf_type: 1,
          status: 1,
          shelf_time: null,
          extend_commission: "",
          default_comment_num: 0,
          custom_report: "",
          custom_price: "",
          goods_detail: "",
          goods_parameter: "",
          after_sale: "",
          attribute: [],
          specs: [],
          deliver_place_area: "",
          deliver_place_city: "",
          deliver_place_provice: "",
          freight_setting: 1,
        },
        attributeValue: [],
        attributeList: [],
        search_keyword: "",
        pageType: "",
        rules: {
          name: { required: true, message: "请输入商品名称", trigger: "blur" },
          category_uuid: {
            required: true,
            message: "请选择商品分类",
            trigger: "change",
          },
          is_service: {
            required: true,
            message: "请选择",
            trigger: "change",
          },
          show_type: {
            required: true,
            message: "请选择",
            trigger: "change",
          },
          freight_uuid: {
            required: true,
            message: "请选择运费模板",
            trigger: "change",
          },
          is_express_delivery: {
            required: true,
            message: "请选择",
            trigger: "change",
          },
          deliver_place_area: {
            required: true,
            message: "请选择发货地",
            trigger: "change",
          },
          price: { required: true, message: "请输入零售价", trigger: "blur" },
          weight: { required: true, message: "请输入重量", trigger: "blur" },
          custom_price: {
            required: true,
            message: "请输入定制价格",
            trigger: "blur",
          },
        },
      };
    },
    created() {
      this.getAttribute();
      this.getData();
      this.getBrand();
      this.getUserGroup();
      this.getCity();
      this.getFreight();
      this.getLevelList();
      this.getList();
    },
    mounted() {
      if (Object.keys(this.$route.query).length !== 0) {
        this.isEdit = true;
        this.pageType = "编辑";
        let params = this.$route.query;
        this.axios({
          method: "get", //请求方法
          headers: {
            "Content-Type": "application/json",
            "X-Access-Token": this.storage.get("__token"),
            Authorization: `Bearer ${this.storage.get("__token")}`,
          },
          url: ` https://time.api.boyalife.cn/v1/cms/Goods/${params.uuid}`,
        })
          .then((res) => {
            let d = res.data.result;
            for (let i in d) {
              this.basicInfoForm[i] = d[i];
            }
            this.value = [this.basicInfoForm.deliver_place_provice, this.basicInfoForm.deliver_place_city, this.basicInfoForm.deliver_place_area];
            this.basicInfoForm.image = this.basicInfoForm.image.map((item) => item.image);
            this.basicInfoForm.only_cash = this.basicInfoForm.only_cash == 1 ? true : false;
            this.basicInfoForm.allow_return = this.basicInfoForm.allow_return == 1 ? true : false;
            this.basicInfoForm.is_purchase_limit = this.basicInfoForm.is_purchase_limit == 1 ? true : false;
            this.basicInfoForm.is_appoint_level = this.basicInfoForm.is_appoint_level == 1 ? true : false;
            this.basicInfoForm.seven_days = this.basicInfoForm.seven_days == 1 ? true : false;
            this.basicInfoForm.is_express_delivery = this.basicInfoForm.is_express_delivery == 1 ? true : false;
            this.basicInfoForm.is_deliver_place = true;

            this.basicInfoForm.shelf_time = new Date(this.basicInfoForm.shelf_time);
            if (this.basicInfoForm.shelf_type == 1) {
              this.basicInfoForm.shelf_time = null;
            }
            this.basicInfoForm.cash_score = this.basicInfoForm.cash_score == 1 ? true : false;
            this.basicInfoForm.customize_score = this.basicInfoForm.customize_score == 1 ? true : false;
            this.basicInfoForm.show_crossed_price = this.basicInfoForm.show_crossed_price == 1 ? true : false;
            this.basicInfoForm.show_less_price_mark = this.basicInfoForm.show_less_price_mark == 1 ? true : false; //是否显示起1是2否
            this.basicInfoForm.shelf_type = Number(this.basicInfoForm.shelf_type);
            this.basicInfoForm.status = Number(this.basicInfoForm.status);
            this.basicInfoForm.hide_sales = this.basicInfoForm.hide_sales == 1 ? true : false;
            this.basicInfoForm.hide_goods = this.basicInfoForm.hide_goods == 1 ? true : false;
            this.basicInfoForm.goods_extend = this.basicInfoForm.goods_extend == 1 ? true : false;
            this.basicInfoForm.extend_commission = Number(this.basicInfoForm.extend_commission);
            this.basicInfoForm.custom_report = Number(this.basicInfoForm.custom_report);
            this.basicInfoForm.default_comment_num = Number(this.basicInfoForm.default_comment_num || 0);
            this.tags = this.basicInfoForm.label;
            if (this.basicInfoForm.group.length > 0) {
              this.basicInfoForm.group_uuid = this.basicInfoForm.group.map((item) => {
                return item.uuid;
              });
            }

            // if (this.basicInfoForm.shop.length > 0) {
            //   this.basicInfoForm.shop_uuid = this.basicInfoForm.shop.map(item => {
            //     return item.uuid
            //   })
            // }
            this.attributeValue = [];
            if (this.basicInfoForm.attribute) {
              this.basicInfoForm.attribute = this.basicInfoForm.attribute.filter((item) => item.attribute_uuid);
            }
            const { attrkey, attribute } = this.basicInfoForm;
            if (attrkey) {
              //兼容旧数据
              this.basicInfoForm.attrkey.map((item) => {
                this.attributeList.map((jtem) => {
                  if (item.attribute_uuid == jtem.uuid) {
                    this.attributeValue.push(jtem);
                  }
                });
              });
            } else if (attribute) {
              const opts = {};
              attribute.forEach((item) => {
                opts[item.attribute_uuid] = true;
              });
              this.attributeValue = this.attributeList.filter(({ uuid }) => opts[uuid]);
            }

            this.sourceAttribute = [];
            this.attributeValue.map((item) => {
              let obj = {};
              obj.name = item.name;
              obj.item = item.values.split(",");
              this.sourceAttribute.push(obj);
              this.randomDate = new Date().getTime();
            });
            setTimeout(() => {
              this.$refs.skuForm.init();
            }, 50);
            this.attribute = [];
            if (attrkey) {
              //兼容旧数据
              this.basicInfoForm.attrkey.map((item) => {
                let obj = {
                  name: "",
                  item: [],
                };
                obj.name = item.name;
                item.attrvalue.map((jtem) => {
                  obj.item.push(jtem.name);
                });
                this.attribute.push(obj);
              });
            } else if (attribute) {
              attribute.map(({ name, values }) => {
                const obj = {
                  name,
                  item: values.map((item) => item.name),
                };
                this.attribute.push(obj);
              });
            }
            this.sku = [];
            this.randomDate = new Date().getTime();
            let obj2 = {};
            this.basicInfoForm.specs.map((item) => {
              obj2 = {};
              if (item.spec_values && item.spec_values.length > 0) {
                item.spec_values.forEach(({ spec_name, value_name }) => {
                  obj2[spec_name] = value_name;
                });
              }
              delete item.specs;
              for (let i in item) {
                if (i != "extenders" && i != "user_levels") {
                  obj2[i] = item[i];
                }
                if (i == "extenders") {
                  for (let j in item[i]) {
                    obj2[j] = item[i][j];
                  }
                }
                if (i == "user_levels") {
                  for (let o in item[i]) {
                    obj2[o] = item[i][o];
                  }
                }
              }
              this.sku.push(JSON.parse(JSON.stringify(obj2)));
            });
            setTimeout(() => {
              this.$refs.skuForm.init();
            }, 1000);
          })
          .catch((err) => {
            this.$message.success(1);
          });
      } else {
        this.$refs.skuForm.init();
        this.pageType = "新增";
      }
    },
    methods: {
      chooseBanners() {
        this.dialogImageVisible = true;
      },
      closeImageDialog() {
        this.dialogImageVisible = false;
      },
      getImageUrl(item) {
        this.basicInfoForm.image.push(item);
      },
      confirmImageDialog(item) {
        item.map((i) => {
          this.basicInfoForm.image.push(i.url);
        });
        this.dialogImageVisible = false;
      },
      // 获取属性
      getList() {
        this.axios({
          method: "get", //请求方法
          headers: {
            "Content-Type": "application/json",
            "X-Access-Token": this.storage.get("__token"),
            Authorization: `Bearer ${this.storage.get("__token")}`,
          },
          url: ` https://time.api.boyalife.cn/v1/cms/GoodsAttribute?search_keyword=${this.search_keyword}`,
        })
          .then((res) => {
            let d = res.data.result.data;
            this.attributeList = d;
            // this.specificateOptions = d
            // this.sourceAttribute = []
            // d.map((item) => {
            //   let obj = {}
            //   obj.name = item.name
            //   obj.item = item.values.split(',')
            //   this.sourceAttribute.push(obj)
            //   this.randomDate = new Date().getTime()
            // })
          })
          .catch((err) => {
            this.$message.error(err.response.data.error.message);
          });
      },
      selectAttribute(v) {
        this.sourceAttribute = [];
        v.map((item) => {
          let obj = {};
          obj.name = item.name;
          obj.item = item.values.split(",");
          this.sourceAttribute.push(obj);
          this.randomDate = new Date().getTime();
        });
        setTimeout(() => {
          this.$refs.skuForm.init();
        }, 50);
      },
      deleteAttribute(v) {
        this.attribute.map((item, index) => {
          for (let i in item) {
            if (item[i] == v.name) {
              this.attribute.splice(index, 1);
              return;
            }
          }
        });
        if (this.attribute.length == 0) this.sku = [];
      },
      isSelect(v) {
        if (this.basicInfoForm.customize_score == true) {
          this.basicInfoForm.cash_score = false;
        }
      },
      isSelect1(v) {
        console.log(v);
        if (this.basicInfoForm.cash_score == true) {
          this.basicInfoForm.customize_score = false;
        }
      },
      addUnit() {
        this.$prompt("请输入规格名", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputType: "text",
          inputPattern: /[a-zA-Z0-9_\u4e00-\u9fa5]+/,
          inputErrorMessage: "规格名不能为空",
        }).then(({ value }) => {
          this.sourceAttribute.unshift({
            name: value,
            item: [],
          });
          this.$refs.skuForm.init();
        });
      },
      getTimes(v) {},
      closeDialog(v) {
        this.tags = JSON.parse(JSON.stringify(v));
        this.labelDialogVisible = false;
      },
      getCityValue(v) {
        this.basicInfoForm.deliver_place_provice = v[0];
        this.basicInfoForm.deliver_place_city = v[1];
        this.basicInfoForm.deliver_place_area = v[2];
      },
      // 会员等级
      getLevelList() {
        this.axios({
          method: "get", //请求方法
          headers: {
            "Content-Type": "text/html;charset=UTF-8",
            "X-Access-Token": this.storage.get("__token"),
            Authorization: `Bearer ${this.storage.get("__token")}`,
          },
          url: ` https://time.api.boyalife.cn/v1/cms/UserLevelSelect`,
        })
          .then((res) => {
            this.levelList = res.data.result;
          })
          .catch((err) => {
            this.$message.error(err.response.data.error.message);
          });
      },
      // 运费模板
      getFreight() {
        this.axios({
          method: "get", //请求方法
          headers: {
            "Content-Type": "text/html;charset=UTF-8",
            "X-Access-Token": this.storage.get("__token"),
            Authorization: `Bearer ${this.storage.get("__token")}`,
          },
          url: ` https://time.api.boyalife.cn/v1/cms/Freight`,
        })
          .then((res) => {
            this.freghtList = res.data.result.data;
          })
          .catch((err) => {
            this.$message.error(err.response.data.error.message);
          });
      },
      // 地区
      getCity() {
        this.axios({
          method: "get", //请求方法
          headers: {
            "Content-Type": "application/json",
            "X-Access-Token": this.storage.get("__token"),
            Authorization: `Bearer ${this.storage.get("__token")}`,
          },
          url: ` https://time.api.boyalife.cn/v1/cms/Region`,
        })
          .then((res) => {
            this.cityList = res.data.result;
          })
          .catch((err) => {
            this.$message.error(err.response.data.error.message);
          });
      },
      // 获取属性
      // getGoodsAttribute() {
      //   this.axios({
      //     method: "get", //请求方法
      //     headers: {
      //       "Content-Type": "application/json",
      //       "X-Access-Token": this.storage.get("__token"),
      //       Authorization: `Bearer ${this.storage.get("__token")}`
      //     },
      //     url: ` https://time.api.boyalife.cn/v1/cms/GoodsAttribute`
      //   })
      //     .then(res => {
      //       let d = res.data.result.data;
      //       this.specificateOptions = d;
      //       this.sourceAttribute = [];
      //       d.map(item => {
      //         let obj = {};
      //         obj.name = item.name;
      //         obj.item = item.values.split(",");
      //         this.sourceAttribute.push(obj);
      //         this.randomDate = new Date().getTime();
      //       });
      //     })
      //     .catch(err => {
      //       this.$message.error(err.response.data.error.message)
      //     });
      // },
      getBrand() {
        this.axios({
          method: "get", //请求方法
          headers: {
            "Content-Type": "application/json",
            "X-Access-Token": this.storage.get("__token"),
            Authorization: `Bearer ${this.storage.get("__token")}`,
          },
          url: ` https://time.api.boyalife.cn/v1/cms/SupplierTree`,
        })
          .then((res) => {
            this.brandList = res.data.result;
          })
          .catch((err) => {
            this.$message.error(err.response.data.error.message);
          });
      },
      getUserGroup() {
        this.axios({
          method: "get", //请求方法
          headers: {
            "Content-Type": "text/html;charset=UTF-8",
            "X-Access-Token": this.storage.get("__token"),
            Authorization: `Bearer ${this.storage.get("__token")}`,
          },
          url: ` https://time.api.boyalife.cn/v1/cms/UserGroupSelect`,
        })
          .then((res) => {
            this.userGroupList = res.data.result;
          })
          .catch((err) => {
            this.$message.error(err.response.data.error.message);
          });
      },
      toPrev() {
        this.active--;
        if (this.active == 0) {
          this.basicInfoForm.goods_detail = this.$refs.detailEditor.html;
        } else if (this.active == 1) {
          this.basicInfoForm.goods_parameter = this.$refs.parameterEditor.html;
        } else if (this.active == 2) {
          this.basicInfoForm.after_sale = this.$refs.saleEditor.html;
        }
      },
      setSpecs() {
        //计算 attribute
        const opts = {};
        const { attribute } = this.basicInfoForm;
        if (attribute && attribute.length > 0) {
          attribute.forEach(({ uuid, name, attribute_uuid, values }) => {
            opts[name] = { uuid, attribute_uuid };
            if (values && values.length > 0) {
              values.forEach((item) => {
                opts[`${name}_${item.name}`] = { ...item };
              });
            }
          });
        }
        const attrs = {};
        this.attributeList.forEach(({ uuid, name }) => {
          attrs[name] = { uuid, name };
        });
        //获取 attribute
        const target = this.attribute.map(({ name, item }) => {
          if (item && item.length > 0) {
            if (opts[name]) {
              return {
                uuid: opts[name].uuid,
                attribute_uuid: opts[name].attribute_uuid,
                name,
                values: item.map((val) => {
                  const curr = opts[`${name}_${val}`] || {};
                  return {
                    uuid: curr.uuid,
                    name: val,
                  };
                }),
              };
            } else {
              if (attrs[name]) {
                return {
                  attribute_uuid: attrs[name].uuid,
                  name,
                  values: item.map((val) => ({ name: val })),
                };
              }
            }
          }
          return null;
        });
        const sku = this.sku.map((item) => {
          const spec_values = [];
          target.forEach(({ uuid, attribute_uuid, name, values }) => {
            const val = item[name];
            if (val) {
              const item = values.find((item) => item.name === val) || {};
              spec_values.push({
                attribute_uuid,
                spec_uuid: uuid,
                spec_name: name,
                value_uuid: item.uuid,
                value_name: val,
              });
            }
          });
          return {
            ...item,
            spec_values,
          };
        });
        this.basicInfoForm.attribute = [...target];
        this.basicInfoForm.specs = JSON.parse(JSON.stringify(sku));
        // this.basicInfoForm.attribute = [];
        // this.attribute.map((item) => {
        //   let obj = {};
        //   obj.key = item.name;
        //   obj.value = item.item;
        //   this.basicInfoForm.attribute.push(obj);
        // });
        // this.basicInfoForm.specs = JSON.parse(JSON.stringify(this.sku));
      },
      toNext() {
        if (this.active == 0) {
          this.$refs.basicInfoForm.validate((valid) => {
            if (valid) {
              if (this.basicInfoForm.image.length < 1) {
                this.$message.error("请至少上传一张项目图片");
                return false;
              } else {
                this.$refs.skuForm.validate((valid) => {
                  if (valid) {
                    this.setSpecs();
                    this.active++;
                  } else {
                    return false;
                  }
                });
              }
            } else {
              return false;
            }
          });
        } else {
          if (this.active == 1) {
            this.basicInfoForm.goods_detail = this.$refs.detailEditor.html;
          }
          if (this.active == 2) {
            this.basicInfoForm.goods_parameter = this.$refs.parameterEditor.html;
          }
          this.active++;
        }
      },
      getAttribute() {
        this.axios({
          method: "get", //请求方法
          headers: {
            "Content-Type": "application/json",
            "X-Access-Token": this.storage.get("__token"),
            Authorization: `Bearer ${this.storage.get("__token")}`,
          },
          url: ` https://time.api.boyalife.cn/v1/cms/AttributeHeader`,
        })
          .then((res) => {
            let d = res.data.result;
            this.structure = [];
            d.map((item) => {
              let obj = {};
              obj.name = item.key;
              obj.label = item.header;
              if (item.key == "image") {
                obj.type = "slot";
              } else {
                obj.type = "input";
              }
              obj.batch = true;

              if (item.key == "retail_price" || item.key == "stock") {
                obj.required = true;
              } else {
                obj.required = false;
              }
              this.structure.push(obj);
              this.randomDate = new Date().getTime();
            });
          })
          .catch((err) => {
            this.$message.error(err.response.data.error.message);
          });
      },
      // 获取商品分类
      getData() {
        this.axios({
          method: "get", //请求方法
          headers: {
            "Content-Type": "application/json",
            "X-Access-Token": this.storage.get("__token"),
            Authorization: `Bearer ${this.storage.get("__token")}`,
          },
          url: ` https://time.api.boyalife.cn/v1/cms/GoodsCategoryTree`,
        })
          .then((res) => {
            this.options = res.data.result;
          })
          .catch((err) => {
            this.$message.error(err.response.data.error.message);
          });
      },
      // 选择spec_img
      chooseSpecImg(slotProps) {
        this.slotProps = slotProps;
        this.insertImgType = "other";
        // this.imgIndex = index
        this.title = "选择图片";
        this.imgType = "chooseThumbnail_image";
        this.dialogVisible = true;
        // this.basicInfoForm.specs[index].image =
      },
      // 选择banner
      chooseBanner() {
        this.title = "选择图片";
        this.imgType = "chooseThumbnail_image";
        this.insertImgType = "projectImg";
        this.dialogVisible = true;
      },

      chooseVideo() {
        this.imgType = "chooseVideo";
        this.dialogVisible = true;
        this.title = "选择视频";
      },
      selectImg(item) {
        this.dialogVisible = false;
        if (this.insertImgType == "projectImg") {
          this.basicInfoForm.image.push(item.url);
        } else {
          this.slotProps.row.image = item.url;
        }
      },
      insertVideoHandler(url) {
        this.dialogVisible = false;
        this.basicInfoForm.video = url;
      },
      // 删除图片
      deleteImg(index) {
        this.basicInfoForm.image.splice(index, 1);
      },
      submitForm() {
        if (this.tags.length > 0) {
          this.basicInfoForm.label_uuid = this.tags.map((item) => {
            return item.uuid;
          });
        }
        this.basicInfoForm.after_sale = this.$refs.saleEditor.html;
        this.basicInfoForm.only_cash = this.basicInfoForm.only_cash = 1;
        this.basicInfoForm.cash_score = this.basicInfoForm.cash_score == true ? 1 : 2;
        this.basicInfoForm.customize_score = this.basicInfoForm.customize_score == true ? 1 : 2;
        this.basicInfoForm.show_crossed_price = this.basicInfoForm.show_crossed_price == true ? 1 : 2;
        this.basicInfoForm.show_less_price_mark = this.basicInfoForm.show_less_price_mark == true ? 1 : 2;
        this.basicInfoForm.hide_sales = this.basicInfoForm.hide_sales == true ? 1 : 2;
        this.basicInfoForm.goods_extend = this.basicInfoForm.goods_extend == true ? 1 : 2;
        this.basicInfoForm.allow_return = this.basicInfoForm.allow_return == true ? 1 : 2;
        this.basicInfoForm.hide_goods = this.basicInfoForm.hide_goods == true ? 1 : 2;
        this.basicInfoForm.is_purchase_limit = this.basicInfoForm.is_purchase_limit == true ? 1 : 2;
        this.basicInfoForm.is_appoint_level = this.basicInfoForm.is_appoint_level == true ? 1 : 2;
        this.basicInfoForm.seven_days = this.basicInfoForm.seven_days == true ? 1 : 2;
        this.basicInfoForm.is_express_delivery = this.basicInfoForm.is_express_delivery == true ? 1 : 2;
        this.basicInfoForm.is_deliver_place = this.basicInfoForm.is_deliver_place == true ? 1 : 2;
        this.basicInfoForm.is_express_delivery = this.basicInfoForm.is_express_delivery == true ? 1 : 2;
        this.basicInfoForm.is_express_delivery = this.basicInfoForm.is_express_delivery == true ? 1 : 2;
        this.basicInfoForm.is_express_delivery = this.basicInfoForm.is_express_delivery == true ? 1 : 2;
        this.basicInfoForm.specs.map((item) => {
          delete item.sku;
        });
        this.basicInfoForm.default_comment_num = Number(this.basicInfoForm.default_comment_num || 0);
        if (Object.keys(this.$route.query).length !== 0) {
          delete this.basicInfoForm.attrkey;
          delete this.basicInfoForm.unitList;
          delete this.basicInfoForm.group;
          delete this.basicInfoForm.label;
          delete this.basicInfoForm.shop;
          delete this.basicInfoForm.delete_time;
          delete this.basicInfoForm.update_time;
          delete this.basicInfoForm.publish_time;
          this.axios({
            method: "put", //请求方法
            headers: {
              "Content-Type": "application/json",
              "X-Access-Token": this.storage.get("__token"),
              Authorization: `Bearer ${this.storage.get("__token")}`,
            },
            data: this.basicInfoForm,
            url: ` https://time.api.boyalife.cn/v1/cms/Goods/${this.$route.query.uuid}`,
          })
            .then((res) => {
              this.$message.success("编辑成功！");
              this.$router.go(-1);
            })
            .catch((err) => {
              this.$message.error(err.response.data.error.message);
            });
        } else {
          this.axios({
            method: "post", //请求方法
            headers: {
              "Content-Type": "application/json",
              "X-Access-Token": this.storage.get("__token"),
              Authorization: `Bearer ${this.storage.get("__token")}`,
            },
            data: this.basicInfoForm,
            url: ` https://time.api.boyalife.cn/v1/cms/Goods`,
          })
            .then((res) => {
              this.$message.success("新增成功！");
              this.$router.go(-1);
            })
            .catch((err) => {
              this.$message.error(err.response.data.error.message);
            });
        }
      },
    },
    beforeDestroy() {
      const editor = this.editor;
      if (editor == null) return;
      editor.destroy(); // 组件销毁时，及时销毁编辑器
    },
  };
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style scoped>
  .addProject {
    margin-bottom: 80px;
  }
  .avatar-uploader >>> .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 50px;
    height: 50px;
    line-height: 50px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .el-form-item .avatar-uploader {
    padding: 10px;
  }
  .specificationsBox {
    padding: 20px;
    border: 1px dashed rgb(223, 223, 223);
  }
  .addBtn {
    padding-bottom: 20px;
    border-bottom: 1px solid rgb(223, 223, 223);
  }
  .el-tag + .el-tag {
    margin-left: 10px;
  }
  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }
  .bdb {
    padding-bottom: 20px;
    border-bottom: 1px solid rgb(232, 232, 232);
  }
  >>> .ipt.el-input {
    width: 300px !important;
  }
  .cover_image_list > div {
    flex-wrap: wrap;
    margin-top: 20px;
    display: flex;
  }
  .cover_image_list .img {
    position: relative;
    border: 1px solid #dcdcdc;
    width: 220px;
    height: 220px;
    margin-right: 10px;
    margin-bottom: 10px;
  }
  .cover_image_list .img .el-icon-delete {
    position: absolute;
    right: 10px;
    top: 10px;
    color: #fff;
    z-index: 2;
    cursor: pointer;
  }
  .cover_image_list .img .el-image {
    width: 100%;
    height: 100%;
  }
  .avatar-uploader {
    position: relative;
  }
  .avatar-uploader .el-icon-delete,
  .video .el-icon-delete {
    font-size: 20px;
    position: absolute;
    right: -24px;
    bottom: 0px;
  }
  .tableBox {
    width: 100%;
    overflow-x: auto;
  }
  .table .el-icon-delete {
    font-size: 14px;
    right: -20px;
  }
  .el-tag + .el-tag {
    margin-left: 0;
  }
  .el-tag {
    margin-right: 5px;
  }
  .el-table .avatar {
    width: 50px;
    height: 50px;
  }
</style>
